/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const DebtStatisticPage = lazyLoad(
  () => import('./index'),
  module => module.DebtStatisticPage
);
